import React from 'react';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';

// Components
import FormInput from 'Console/components/common/form/FormInput';
import FormItemSelect from 'Console/components/common/form/FormItemSelect';
import FormItemSwitch from 'Console/components/common/form/FormItemSwitch';

// Constants
import { VALUE_OF_TYPES, KIND_OF_USERS } from 'Console/constants/appConstants';

const styles = (theme) => ({
    root: {
        width: '45%',
        margin: 'auto',
        [theme.breakpoints.between('sm', 'md')]: {
            width: '90%',
        },
    },
    items: {
        'align-items': 'center',
        'justify-content': 'space-between',
        display: 'flex',
        flexDirection: 'row',
    },
    formInput: {
        flexBasis: '66.66%',
        overflow: 'hidden',
        marginBottom: theme.typography.pxToRem(20),
    },
    formItemSelect: {
        flexBasis: '66.66%',
        marginBottom: theme.typography.pxToRem(20),
    },
    switchLabel: {
        flexBasis: '29%',
        marginRight: '1%',
    },
    swithcWrapper: { marginBottom: theme.typography.pxToRem(20) },
    label: {
        flexBasis: '29%',
        marginRight: '4%',
        marginBottom: theme.typography.pxToRem(20),
    },
});

const CreateNewSegment = ({ classes, intl, form, segmentToEdit }) => {
    const { getFieldValue } = form;
    return (
        <>
            <Grid className={classes.root} container>
                <Grid container direction="row" alignItems="center" className={classes.swithcWrapper}>
                    <Typography variant="body1" className={classes.switchLabel}>
                        {intl.formatMessage({ id: 'Buttons.switchActive' })}
                    </Typography>

                    <FormItemSwitch
                        initialValue={(segmentToEdit && segmentToEdit.active) || true}
                        form={form}
                        formItemKey="active"
                    />
                </Grid>

                {(!segmentToEdit || segmentToEdit.kind !== 'System Collected') && (
                    <>
                        {(!segmentToEdit ||
                            (segmentToEdit.kind !== 'User Frontend' &&
                                segmentToEdit.kind !== 'User Collected')) && (
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                className={classes.items}
                            >
                                <Typography className={classes.label} variant="body1">
                                    {intl.formatMessage({ id: 'Segments.createSegment.kind' })}
                                </Typography>
                                <Grid className={classes.formItemSelect}>
                                    <FormItemSelect
                                        initialValue={
                                            segmentToEdit ? segmentToEdit.kind : KIND_OF_USERS[0].value
                                        }
                                        form={form}
                                        fullWidth={false}
                                        formItemKey="kind"
                                        optionList={KIND_OF_USERS}
                                    />
                                </Grid>
                            </Grid>
                        )}

                        <Grid>
                            {!segmentToEdit && getFieldValue('kind') === 'userCollected' && (
                                <Typography className={classes.label} variant="body1">
                                    {intl.formatMessage({ id: 'Settings.createSegment.message1' })}
                                </Typography>
                            )}

                            {!segmentToEdit && getFieldValue('kind') === 'userFrontend' && (
                                <Typography className={classes.label} variant="body1">
                                    {intl.formatMessage({ id: 'Settings.createSegment.message2' })}
                                </Typography>
                            )}

                            {!segmentToEdit && getFieldValue('kind') === 'systemCollected' && (
                                <Typography className={classes.label} variant="body1">
                                    {intl.formatMessage({ id: 'Settings.createSegment.message3' })}
                                </Typography>
                            )}
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            className={classes.items}
                            style={{ marginBottom: '5rem' }}
                        >
                            <Typography variant="body1" className={classes.label}>
                                {intl.formatMessage({
                                    id: 'Segments.createSegment.valueType',
                                })}
                            </Typography>
                            <Grid className={classes.formItemSelect}>
                                <FormItemSelect
                                    initialValue="keyword"
                                    form={form}
                                    fullWidth={false}
                                    formItemKey="valueTypes"
                                    optionList={VALUE_OF_TYPES}
                                />
                            </Grid>
                        </Grid>

                        <Grid container direction="row" alignItems="center" className={classes.items}>
                            <Typography variant="body1" className={classes.label}>
                                {intl.formatMessage({ id: 'Segments.createSegment.name' })}
                            </Typography>

                            <Grid className={classes.formInput}>
                                <FormInput
                                    isRequired
                                    fullWidth={false}
                                    form={form}
                                    type="text"
                                    formItemKey="name"
                                    initialValue={segmentToEdit ? segmentToEdit.name : ''}
                                    validateTrigger="onChange"
                                    placeholder={intl.formatMessage({
                                        id: 'Settings.createSegment.placeholder',
                                    })}
                                />
                            </Grid>
                        </Grid>

                        {(!segmentToEdit || segmentToEdit.kind !== 'User Collected') && (
                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                className={classes.items}
                            >
                                <Typography variant="body1" className={classes.label}>
                                    {intl.formatMessage({ id: 'Segments.createSegment.systemKey' })}
                                </Typography>

                                <Grid className={classes.formInput}>
                                    <FormInput
                                        isRequired
                                        fullWidth={false}
                                        form={form}
                                        type="text"
                                        formItemKey="systemKey"
                                        initialValue={segmentToEdit ? segmentToEdit.systemKey : ''}
                                        validateTrigger="onChange"
                                        placeholder={intl.formatMessage({
                                            id: 'Settings.createSegment.placeholder',
                                        })}
                                    />
                                </Grid>
                            </Grid>
                        )}
                        <Grid
                            container
                            direction="row"
                            alignItems="center"
                            className={classes.items}
                            style={{ marginBottom: '2rem' }}
                        >
                            <Typography variant="body1" className={classes.label}>
                                {intl.formatMessage({ id: 'Segments.createSegment.description' })}
                            </Typography>

                            <Grid className={classes.formInput}>
                                <FormInput
                                    isRequired={false}
                                    fullWidth={false}
                                    form={form}
                                    type="text"
                                    initialValue={segmentToEdit ? segmentToEdit.description : ''}
                                    multiline
                                    rows={2}
                                    rowsMax={4}
                                    formItemKey="description"
                                    validateTrigger="onChange"
                                    placeholder={intl.formatMessage({
                                        id: 'Settings.createSegment.placeholder',
                                    })}
                                />
                            </Grid>
                        </Grid>
                    </>
                )}
            </Grid>
        </>
    );
};

export default injectIntl(withStyles(styles)(CreateNewSegment));
